import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Redirect } from "react-router"
import { routePaths } from "../.."
import { failMessage } from "../../../Actions/Client/MessagesActions"
import { WorkerSignUp } from "../../../Components/Views/Dashboard/Sections/Worker/WorkerSignUp"
import { OrgRouteComponentProps } from "../../RouteProps"

export function WorkerSignUpRoute({
    match,
    location
}: OrgRouteComponentProps<{ workerId: string }>) {
    const search = new URLSearchParams(location.search)
    const code = search.get("code")
    const workerId = Number.parseInt(match.params.workerId, 10)
    const dispatch = useDispatch()

    useEffect(() => {
        if (Number.isNaN(workerId) || code === null) {
            dispatch(failMessage("Sign up url is invalid"))
        }
    }, [code, dispatch, workerId])

    if (Number.isNaN(workerId) || code === null) {
        return <Redirect to={routePaths.home()} />
    }

    return (
        <WorkerSignUp
            orgUsername={match.params.orgUsername}
            workerId={workerId}
            code={code}
        />
    )
}
